import React from "react";

const LegacyPrototype: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-stone-900 text-sky-50">
      <div className="w-full bg-stone-800 border-b border-stone-700 px-6 py-4 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Legacy Wetland Game Prototype</h1>
          <p className="text-sm text-stone-200">
            This is the original static prototype preserved for reference. Some features may rely on the legacy
            websocket server configuration.
          </p>
        </div>
        <div className="flex gap-3">
          <a
            className="px-4 py-2 rounded bg-stone-700 hover:bg-stone-600 transition-colors text-sm font-medium border border-stone-500"
            href="/legacy/index.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open in New Tab
          </a>
        </div>
      </div>
      <div className="grow flex-1 bg-stone-950">
        <iframe
          title="Legacy Wetland Game Prototype"
          src="/legacy/index.html"
          className="w-full h-full border-0"
        />
      </div>
    </div>
  );
};

export default LegacyPrototype;
